import { useMutation, useQueryClient } from '@tanstack/react-query';
import http from 'helpers/requests';

export const useUpdateOperator = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (operator) => {
      const response = await http.put('/operators', operator);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['loggedOperator'] });
    },
  });
};
